import IconButton from '@/global/components/Button/IconButton'
import { GridRenderCellParams } from '@/global/components/DataGrid/utils/types'
import Dialog from '@/global/guides/Dialog'
import { UserRoundMinusIcon } from 'lucide-react'
import { queryClient } from 'providers/ReactQuery'
import { useMemo, useState } from 'react'
import { centroCustoFuncionario_api } from 'service/api'
import { toast } from 'sonner'

export function DesassociarFuncionarioCentroCusto(props: GridRenderCellParams) {
    const MemoizedModal = useMemo(() => {
        return <Modal {...props} />
    }, [props.row.id])

    return MemoizedModal
}

function Modal({ row }: GridRenderCellParams) {
    const [open, setOpen] = useState(false)
    const { mutateAsync } = centroCustoFuncionario_api.mutations.useDelete({
        onSuccess: async () => {
            toast.success('Funcionário desassociado com sucesso')
            await queryClient.invalidateQueries([
                'centroCusto',
                row.centroCustoId,
            ])
        },
        onError: () => {
            toast.error('Erro ao desassociar funcionário')
        },
    })

    function handleSubmit() {
        return mutateAsync(row.id)
    }

    return [
        <IconButton
            onClick={() => setOpen(true)}
            key="botao"
            title="Desassociar"
        >
            <UserRoundMinusIcon />
        </IconButton>,
        <Dialog.Root
            key="modal"
            open={open}
            onClose={() => setOpen(false)}
            width="fit"
            onSubmit={handleSubmit}
        >
            <Dialog.Content>
                Deseja desassociar o funcionário deste centro de custo?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit>
                    Sim
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>,
    ]
}
